import { AdvancedPlansProductData } from '../types';
import {
  ProductFamily,
  PaymentCycle,
  CurrentPlanInOfferingMode,
  ProductChangeType,
} from '../enums';
import { AppStore } from '../stores/App.store';

export class AdvancedPlansProductModel {
  private readonly productData: AdvancedPlansProductData;
  isProductInSale: boolean = false;
  isCurrentPlanProduct: boolean;
  isCurrentPlanSameCode: boolean;

  constructor(
    data: AdvancedPlansProductData,
    private readonly appStore: AppStore,
  ) {
    const {
      currentPlanInOfferingMode,
      appContext: { currentPlanDetails, isDynamicOffering },
    } = appStore;
    this.productData = data;
    this.isCurrentPlanProduct =
      currentPlanInOfferingMode ===
        CurrentPlanInOfferingMode.ProductFullMatch &&
      (data.id === currentPlanDetails!.planId ||
        (isDynamicOffering && data.guid === currentPlanDetails!.guid));

    this.isCurrentPlanSameCode =
      appStore.currentPlanInOfferingMode ===
        CurrentPlanInOfferingMode.ProductPartialMatch &&
      data.productCode === appStore.appContext.currentPlanDetails!.productCode;

    this.isProductInSale =
      data.productFamily === ProductFamily.Pro ||
      data.productFamily === ProductFamily.Unlimited ||
      data.productFamily === ProductFamily.Evolve ||
      data.productFamily === ProductFamily.Grow ||
      data.productFamily === ProductFamily.VIP ||
      data.productFamily === ProductFamily.Ultra ||
      data.productFamily === ProductFamily.Extra ||
      data.productFamily === ProductFamily.Scale ||
      data.productFamily === ProductFamily.Boost;
  }

  private readonly findCycle = (cycle: PaymentCycle) =>
    this.productData.cycles.find((c) => c.cycleId === cycle);

  getYearlyFullPrice = () => {
    const yearly = this.findCycle(PaymentCycle.YEARLY);
    return yearly ? yearly.monthlyFullPrice : NaN;
  };

  getfirstCycleYearlyMonthly = () => {
    const yearly = this.findCycle(PaymentCycle.YEARLY);
    return yearly ? yearly.firstPeriodPriceMonthly : NaN;
  };

  getYearlyActualPrice = () => {
    const yearly = this.findCycle(PaymentCycle.YEARLY);
    return yearly ? yearly.monthlyActualPrice : NaN;
  };

  getActualPriceByCycle = (cycle: PaymentCycle) => {
    const nYearly = this.findCycle(cycle);
    return nYearly ? nYearly.monthlyActualPrice : this.getYearlyActualPrice();
  };

  getFullPriceByCycle = (cycle: PaymentCycle) => {
    const nYearly = this.findCycle(cycle);
    return nYearly ? nYearly.monthlyActualPrice : this.getYearlyFullPrice();
  };

  isSelected = () => {
    const { isChangePlan, getDefaultCurrentProductForPlanType } = this.appStore;
    return (
      getDefaultCurrentProductForPlanType.id === this.productData.id &&
      (!isChangePlan ||
        this.productData.productChangeType === ProductChangeType.Upgrade)
    );
  };

  getPriceToDisplay = () =>
    this.getfirstCycleYearlyMonthly() || this.getYearlyActualPrice();

  isPurchaseEnabled = () => {
    const { isSecondUpgrade } = this.appStore;
    return (
      this.productData.isEnabledForSecondUpgrade &&
      (!this.isCurrentPlanProduct || isSecondUpgrade)
    );
  };
  getId = () => this.productData.id;
  getCode = () => this.productData.productCode;
  getHatLabel = () => this.productData.hatKey;
  getType = () => this.productData.type;
  getName = () => this.productData.productName;
  shouldShowAdsNote = () => this.productData.shouldShowAdsNote;
  isEnterprise = () =>
    this.productData.productFamily === ProductFamily.Enterprise;
  getProductChangeType = () => this.productData.productChangeType;
  getDiscountPercent = () => this.productData.firstPeriodDiscount;
  getSaleDiscountPercentage = () => this.productData.saleDiscountPercentage;
}
